import React, { Fragment, useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import APICall from "../../services/apiCall";
import Loader from "../common/Loader";
import AppContext from "../../context/Context";

const RequestKeyModal = ({ masterCustomerID }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    let params = {
      master_customer_id: masterCustomerID,
    };
    APICall.servertrip("GET", "master_customer_id_practice_keys", loginUserDetails, params).then(
      (res) => {
        setData(res.data.items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  }, []);

  const CustomTotal = ({ sizePerPage, totalSize, page, lastIndex }) => (
    <span>
      {(page - 1) * sizePerPage + 1} to {lastIndex > totalSize ? totalSize : lastIndex} of {totalSize}
    </span>
  );

  const options = {
    custom: true,
    sizePerPage: 6,
    totalSize: data.length,
  };

  const handleNextPage = ({ page, onPageChange }) => () => {
    onPageChange(page + 1);
  };

  const handlePrevPage = ({ page, onPageChange }) => () => {
    onPageChange(page - 1);
  };

  const columns = [
    {
      dataField: "master_customer_id",
      text: "Master Customer ID",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "practice_id",
      text: "Practice ID",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "practice_name",
      text: "Practice name",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "practice_key",
      text: "Practice Key",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "spu_download_key",
      text: "SPU Installation Key",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
  ];

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <ToolkitProvider keyField="id" data={data} columns={columns} search>
          {(props) => (
            <>
              <PaginationProvider pagination={paginationFactory(options)}>
                {({ paginationProps, paginationTableProps }) => {
                  const lastIndex = paginationProps.page * paginationProps.sizePerPage;

                  return (
                    <Fragment>
                      <div className="table-responsive">
                        <BootstrapTable
                          bootstrap4
                          keyField="api_unique_id"
                          data={data}
                          columns={columns}
                          noDataIndication="No data to be shown!"
                          bordered={true}
                          classes="table-dashboard table-sm fs--1 border-bottom border-right border-200 mb-0 table-dashboard-th-nowrap"
                          rowClasses="btn-reveal-trigger border-top border-200"
                          headerClasses="bg-200 text-900 border-y border-200"
                          {...paginationTableProps}
                          {...props.baseProps}
                        />
                      </div>
                      <Row noGutters className="px-1 py-3">
                        <Col className="pl-3 fs--1">
                          <CustomTotal {...paginationProps} lastIndex={lastIndex} />
                        </Col>
                        <Col xs="auto" className="pr-3">
                          <Button
                            color={paginationProps.page === 1 ? "light" : "primary"}
                            size="sm"
                            onClick={handlePrevPage(paginationProps)}
                            disabled={paginationProps.page === 1}
                            className="px-4"
                          >
                            Previous
                          </Button>
                          <Button
                            color={lastIndex >= paginationProps.totalSize ? "light" : "primary"}
                            size="sm"
                            onClick={handleNextPage(paginationProps)}
                            disabled={lastIndex >= paginationProps.totalSize}
                            className="px-4 ml-2"
                          >
                            Next
                          </Button>
                        </Col>
                      </Row>
                    </Fragment>
                  );
                }}
              </PaginationProvider>
            </>
          )}
        </ToolkitProvider>
      )}
    </div>
  );
};

export default RequestKeyModal;
